/**
 * ApprovalLevelService
 * Service for ApprovalLevel entity operations
 * Route: api/approvallevel
 * Controller: ApprovalLevelController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ApprovalLevelService
 * Handles approval level CRUD operations
 * Maps to /api/approvallevel endpoint
 */
export class ApprovalLevelService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ApprovalLevelService.DEFAULT_SERVICE_PATH,
            basePath: ApprovalLevelService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Get all active approval levels
     * @returns Array of active approval levels
     */
    async getActive() {
        const response = await this.http.get(this.buildUrl('active'));
        return response.data ?? [];
    }
}
ApprovalLevelService.DEFAULT_SERVICE_PATH = 'procurements';
ApprovalLevelService.BASE_PATH = 'api/approvallevel';
//# sourceMappingURL=ApprovalLevelService.js.map